<template>
  <div
    id="flyout-container"
    :class="`v-overlay ${isFlyoutActive ? 'flyout-active' : ''}`"
    @click="handleOutsideClick"
    @keyup.esc="handleOutsideClick"
  >
    <div v-if="!noOverlay" :class="`flyout-overlay ${invisibleOverlay ? 'invisible' : ''}`" />
    <BaseFlyout :class="flyoutClass" :width="width ?? 396" v-bind="$attrs" v-model="boundValue">
      <div class="flyout-header d-flex justify-space-between pa-5">
        <slot name="flyout-header">
          <h3 class="heading-3 semibold w-100">{{ title }}</h3>
        </slot>
        <v-icon icon="mdi:mdi-close" size="24" @click="boundValue = false" />
      </div>
      <v-divider dark />
      <slot />
      <v-divider dark />
      <div class="flyout-bottom">
        <slot name="flyout-bottom" />
      </div>
    </BaseFlyout>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { BaseFlyout } from '../base'

const boundValue = defineModel({ default: false })
const emit = defineEmits(['confirm-dismiss'])
const props = defineProps<{
  noOverlay?: boolean
  flyoutClass?: string
  persistent?: boolean
  invisibleOverlay?: boolean
  width?: number
  title?: string
}>()
// const listeners = useListeners();

const isFlyoutActive = computed(() => boundValue.value)

const handleOutsideClick = (event: MouseEvent | KeyboardEvent) => {
  event.stopPropagation()
  if (props.persistent) return
  const targetElement: HTMLElement | null = event.target as HTMLElement
  if (!targetElement?.classList.contains('flyout-overlay')) return
  boundValue.value = false
  emit('confirm-dismiss')
  //   if (listeners['confirm-dismiss']) {
  //     emit('confirm-dismiss');
  //   } else {
  //     emit('input', false);
  //   }
}
</script>
<style scoped lang="scss">
#flyout-container {
  z-index: 1010;
  .flyout-overlay {
    position: inherit;
    top: inherit;
    left: inherit;
    right: inherit;
    bottom: inherit;
    opacity: 0;
    transition: all 0.6s ease;
  }
  &.flyout-active {
    pointer-events: fill;
  }
  &.flyout-active .flyout-overlay {
    background-color: rgb(var(--v-theme-gray_900));
    opacity: 0.1;
    &.invisible {
      opacity: 0;
    }
  }
  // .slide-enter-active {
  //   transition: all 2s ease;
  // }
  // .slide-leave-active {
  //   transition: all 2s ease;
  // }
  // .slide-enter,
  // .slide-leave-to {
  //   transform: translateX(100%);
  //   opacity: 0;
  // }
  // .flyout-header {

  // }
  .flyout-bottom {
    // position: absolute;
    width: 100%;
    bottom: 0;
    background-color: #ffffff;
  }
}
</style>
